import * as t from './action_types';

const INITIAL_STATE = {
    snackbarOpened: false,
    snackbarMessage: '',
    snackbarType: null,
};

const notification = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case t.OPEN_SNACKBAR: {
            const { snackbarMessage, snackbarType } = action.payload;
            return {
                ...state,
                snackbarOpened: true,
                snackbarMessage,
                snackbarType,
            };
        }
        case t.CLOSE_SNACKBAR:
            return {
                ...state,
                snackbarOpened: false,
                snackbarMessage: '',
                snackbarType: null,
            };
        default:
            return state;
    }
};

export default notification;
